/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StepStateType = {
    Default: 'Default',
    Complete: 'Complete',
    Invalid: 'Invalid',
    NotRequired: 'NotRequired'
} as const;
export type StepStateType = typeof StepStateType[keyof typeof StepStateType];


export function StepStateTypeFromJSON(json: any): StepStateType {
    return StepStateTypeFromJSONTyped(json, false);
}

export function StepStateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepStateType {
    return json as StepStateType;
}

export function StepStateTypeToJSON(value?: StepStateType | null): any {
    return value as any;
}

